// create a name generator that generates names with nouns and adjectives (50 nouns and 50 adjectives)
const nouns = [
    'cat',
    'dog',
    'car',
    'tree',
    'house',
    'computer',
    'phone',
    'book',
    'pen',
    'chair',
    'table',
    'lamp',
    'bottle',
    'glass',
    'shoe',
    'shirt',
    'pants',
    'hat',
    'watch',
    'wallet',
    'key',
    'bag',
    'food',
    'drink',
    'music',
    'movie',
    'game',
    'toy',
    'art',
    'photo',
    'flower',
    'bird',
    'fish',
    'horse',
    'cow',
    'sheep',
    'pig',
    'chicken',
    'duck',
    'goose',
    'bee',
    'ant',
    'butterfly',
    'spider',
    'worm',
    'rock',
    'mountain',
    'river',
    'ocean',
    'sky',
];

const adjectives = [
    'happy',
    'sad',
    'angry',
    'excited',
    'bored',
    'tired',
    'hungry',
    'thirsty',
    'sleepy',
    'scared',
    'brave',
    'smart',
    'funny',
    'silly',
    'weird',
    'cool',
    'hot',
    'cold',
    'big',
    'small',
    'fast',
    'slow',
    'loud',
    'quiet',
    'bright',
    'dark',
    'colorful',
    'dull',
    'clean',
    'dirty',
    'new',
    'old',
    'young',
    'wise',
    'foolish',
    'rich',
    'poor',
    'strong',
    'weak',
    'friendly',
];

function getRandomElement(arr: string[]) {
    return arr[Math.floor(Math.random() * arr.length)];
}

export function generateName() {
    const noun = getRandomElement(nouns);
    const adjective = getRandomElement(adjectives);
    return `${adjective} ${noun}`;
}
